export enum USER_API_TAGS {
  User = 'User',
  UserMe = 'UserMe',
  UserStreak = 'UserStreak',
  Avatar = 'Avatar',
  OnboardingProgress = 'OnboardingProgress',
  LeagueParticipation = 'LeagueParticipation',
  UserSettings = 'UserSettings',
}
export enum FAMILY_API_TAGS {
  Family = 'family',
}

/** School (b2s) admin provisioning. */
export enum SCHOOL_ADMIN_API_TAGS {
  School = 'School',
  Classroom = 'SchoolClassroom',
  Teacher = 'SchoolTeacher',
}

/** School (b2s) teacher dashboard. One tag per endpoint — a shared tag would refetch all three. */
export enum TEACHER_PANEL_API_TAGS {
  DashboardOverviewStats = 'TeacherDashboardOverviewStats',
  DashboardCurriculumStats = 'TeacherDashboardCurriculumStats',
  DashboardStudents = 'TeacherDashboardStudents',
}

export enum CurriculumTutorialUserStatus {
  NotStarted = 'not_started',
  CompletedTutorial1 = 'completed_tutorial_1',
  CompletedTutorial2 = 'completed_tutorial_2',
}

export enum CurriculumTutorialStatusEnum {
  SHOW_TUTORIAL1 = 'show_tutorial_1',
  SHOW_TUTORIAL2 = 'show_tutorial_2',
  DO_NOT_SHOW_TUTORIAL = 'do_not_show_tutorial',
}

export enum ACCOUNT_API_TAGS {
  EmailVerifyStatus = 'EmailVerifyStatus',
}

export enum ADMIN_API_TAGS {
  Admin = 'Admin',
  Tutor = 'Tutor',
  StripeGeoProduct = 'StripeGeoProduct',
  TshirtClaims = 'TshirtClaims',
  SubscriptionPermission = 'SubscriptionPermission',
  FeatureFreeAccessDuration = 'FeatureFreeAccessDuration',
  TimeTrackingViewKeyRule = 'TimeTrackingViewKeyRule',
}

export enum SESSION_API_TAGS {
  Session = 'Session',
  Sessions = 'Sessions',
}

export enum MULTGAME_API_TAGS {
  GameUser = 'GameUser',
  GameCertificates = 'GameCertificates',
  TshirtClaim = 'TshirtClaim',
}

export enum STUDENT_API_TAGS {
  StudentPreference = 'StudentPreference',
}

export enum USER_VIDEO_WATCH_API_TAGS {
  VideoWatchCount = 'VideoWatchCount',
}

export enum USER_FEEDBACK_API_TAGS {
  ContentFeedbackToday = 'ContentFeedbackToday',
}

/** Thumbs votes on videos. Separate from USER_FEEDBACK_API_TAGS — a different table and a different grain. */
export enum VIDEO_FEEDBACK_API_TAGS {
  LatestVote = 'VideoFeedbackLatestVote',
}

export enum NOTIFICATION_FEATURE_ID {
  leaderboard = 'leaderboard',
}

export enum NOTIFICATION_SUBFEATURE_ID {
  prevWeekResult = 'prev-week-result',
}
export enum NOTIFICATION_DISCOUNT_TYPE {
  FRIENDS_AND_FAMILY = 'friends-and-family',
}
export enum CURRICULUM_TYPE {
  CURRICULUM_CURRENT_GRADE = 'curriculum-current-grade',
  CURRICULUM_CERTIFICATE = 'curriculum-certificate',
  CURRICULUM_LEVEL_PROGRESS = 'curriculumLevelProgress',
  CURRICULUM_PROGRESS_MIGRATION_MODAL = 'CurriculumProgressMigrationModal',
  CURRICULUM_USER_STATS = 'CurriculumUserStats',
  CURRICULUM_PROGRESS_V2 = 'CurriculumProgressV2',
  CURRICULUM_MAPPING_QUIZ_TASKS = 'CurriculumMappingQuizTasks',
}

export enum BOOTCAMP_TYPE {
  BOOTCAMP_VIDEO_WATCHED = 'bootcamp-video-watched',
}

// Its own tag namespace, distinct from CURRICULUM_TYPE, so a standalone-progress write never
// invalidates/refetches curriculum progress UI (R5 isolation, mirrored from the hom-api side).
export enum STANDALONE_CONTENT_TYPE {
  STANDALONE_CONTENT_PROGRESS = 'standalone-content-progress',
}

export enum XP_FREEZE_API_TAGS {
  XP_FREEZE = 'xp-freeze',
}

function enumValsToArray(enumObj: { [key: string]: string }): string[] {
  return Object.keys(enumObj).map((key) => enumObj[key])
}

export const HOM_API_TAGS = [
  ...enumValsToArray(ACCOUNT_API_TAGS),
  ...enumValsToArray(USER_API_TAGS),
  ...enumValsToArray(ADMIN_API_TAGS),
  ...enumValsToArray(SESSION_API_TAGS),
  ...enumValsToArray(MULTGAME_API_TAGS),
  ...enumValsToArray(STUDENT_API_TAGS),
  ...enumValsToArray(USER_VIDEO_WATCH_API_TAGS),
  ...enumValsToArray(USER_FEEDBACK_API_TAGS),
  ...enumValsToArray(VIDEO_FEEDBACK_API_TAGS),
  ...enumValsToArray(CURRICULUM_TYPE),
  ...enumValsToArray(BOOTCAMP_TYPE),
  ...enumValsToArray(FAMILY_API_TAGS),
  ...enumValsToArray(STANDALONE_CONTENT_TYPE),
  ...enumValsToArray(TEACHER_PANEL_API_TAGS),
  ...enumValsToArray(XP_FREEZE_API_TAGS),
]
